// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2R0yt","content":"styles_content__3Zh3E","selectAll":"styles_selectAll__3f0zu"};